/** Stable identity for a wizard step, independent of its display position. */
export type WizardStepKey = 'type' | 'configure' | 'test' | 'schedule' | 'review';

export interface WizardStepMeta {
  /** 1-based position within the *active* step list (see getWizardSteps). */
  id: number;
  key: WizardStepKey;
  title: string;
  description: string;
}

// Master ordered list. The Schedule step (#273) is conditional -- it is
// dropped for connector types whose schema reports supports_scheduling: false.
const ALL_WIZARD_STEPS: ReadonlyArray<Omit<WizardStepMeta, 'id'>> = [
  { key: 'type', title: 'Choose type', description: 'Pick a connector' },
  { key: 'configure', title: 'Configure', description: 'Connection details' },
  { key: 'test', title: 'Test', description: 'Verify the connection' },
  { key: 'schedule', title: 'Schedule', description: 'Set a run cadence' },
  { key: 'review', title: 'Review & create', description: 'Confirm and finish' },
];

/**
 * Build the active wizard steps. The Schedule step is omitted when the
 * connector type does not support scheduling; IDs are 1-based positions
 * within the returned (active) list so the rail and renderer stay in sync.
 */
export const getWizardSteps = (supportsScheduling: boolean = true): WizardStepMeta[] =>
  ALL_WIZARD_STEPS
    .filter((s) => s.key !== 'schedule' || supportsScheduling)
    .map((s, i) => ({ ...s, id: i + 1 }));

// Default scheduling-capable 5-step list. Used as the rail's fallback and by
// consumers that don't yet know the connector type.
export const WIZARD_STEPS: WizardStepMeta[] = getWizardSteps(true);
